import { useState } from 'react';
import { WoundPatientsTable } from './WoundPatientsTable';
import { PageLayout } from '~/shared/PageLayout';
import { Bandage } from 'lucide-react';
import { Section } from '~/shared/section/Section';
import { DataTableFilterInjectContextProvider } from '~/shared/data-tables/query/DataTableFilterInjectContext';
import { QueryDataTableFilterBar } from '~/shared/data-tables/query/QueryDataTableFilterBar';
import { PatientFilter } from '../scheduling/filters/Filters';
import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { Button } from '~/shared/components/buttons/Button';
import { TextField } from '~/shared/forms/controls/base-fields/TextField';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';

export function WoundPatients() {
	return (
		<PageLayout pageHeader={{ title: 'Wounds', description: 'On Service Wound Patients', TitleIcon: Bandage }}>
			<Section>
				<DataTableFilterInjectContextProvider>
					<div className="space-y-4">
						<QueryDataTableFilterBar>
							<FilterBar.Item label="Patient">
								<PatientFilter />
							</FilterBar.Item>
							<FilterBar.Item label="Interventions">
								<WoundInterventionSearch />
							</FilterBar.Item>
						</QueryDataTableFilterBar>
						<WoundPatientsTable />
					</div>
				</DataTableFilterInjectContextProvider>
			</Section>
		</PageLayout>
	);
}

export function WoundInterventionSearch() {
	const [interventionSearch, setInterventionSearch] = useQueryDataTableFilter({
		name: 'integumentaryInterventions',
		convertFromQueryParam: value => value.toString(),
		operator: '@='
	});
	const [searchTerm, setSearchTerm] = useState<string | undefined>(interventionSearch);
	const [prevInterventionSearch, setPrevInterventionSearch] = useState(interventionSearch);
	if (interventionSearch !== prevInterventionSearch) {
		setPrevInterventionSearch(interventionSearch);
		if (!interventionSearch) {
			setSearchTerm(undefined);
		}
	}
	return (
		<>
			<TextField
				label="Search Interventions"
				hideLabel
				inputProps={{ placeholder: 'Search Interventions' }}
				value={searchTerm}
				className="w-[500px]"
				onChange={setSearchTerm}
			/>
			<Button
				appearance="outline"
				intent="neutral"
				actionType="search"
				isDisabled={!searchTerm}
				onClick={() => setInterventionSearch(searchTerm!)}
			/>
		</>
	);
}
